'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import Promise from 'bluebird';
import {slideToggle} from './slide';
import { openModal } from '../ui/modal'

export default (selector) => {

	const $container = $(selector);

	const templates = {
		cartAlert: $('#mustache-cart-alert').html(),
		alert: $('#mustache-alert').html()
	};

	$container.on('click', '.v4-alert .close-button', (e) => {
		const $alert = $(e.target).closest('.v4-alert');
		$alert.slideUp('fast', () => {
			$container.trigger('closeAlert', [$alert]);
			$alert.remove();
		});
	});

	$container.on('click', '.v4-alert .read-more-link', function(e) {
		e.stopPropagation();
		e.preventDefault();
		slideToggle($(this).siblings('.read-more-content'));
	});

	$container.on('click', '.v4-alert .info-modal-open', function() { openModal($(this), { compact: true, centerVertical: true })});

	return (msg, i) => {
		const { itemId, type, message, kind, title } = msg;
		const alert = {
			itemId: itemId || 'id-' + i,
			type: type || 'info',
			message,
			kind,
			title
		};

		const $item = $container.find(`*[class*="-item"][data-id="${alert.itemId}"]`);

		const $itemAlert = $item.length
			? $(Mustache.render(templates.cartAlert, alert, { alert: templates.alert }))
			: $(Mustache.render(templates.alert, alert));

		let $alert = $('<div/>');

		if ($item.length) {
			$itemAlert.find('.alert').addClass('up')
			$itemAlert.insertAfter($item);
			$alert = $itemAlert.find('.alert');
		}
		else if (!itemId) {
			$alert = $itemAlert;
			$container.prepend($itemAlert);
		}

		return new Promise(resolve => {
			$alert.slideDown('fast', resolve);
			if (!msg.persistent) {
				setTimeout(() => $alert.slideUp('fast'), 3000);
			}
		});
	}
}
